/* eslint-disable no-unused-expressions */
import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';

import { Select, DatePicker, Icon, Button, theme, Modal } from 'fpay-ui';
import { useReports } from 'hooks';
import moment from 'moment';
import { getFormatedDate } from '@helpers';
import { useSelector } from 'react-redux';

import { isAllowed } from 'helpers/auth';
import FiltersMobile from './FiltersMobile';
import CleanFilter from '../SelectType/CleanFilter';

import {
  StyledFilter,
  SyledDateContainer,
  IconButton,
  StyledDateFilter,
  StyledDatePicker,
} from './CommonComponents';

const ContainerLG = styled.div`
  display: none;
  @media (min-width: 769px) {
    display: flex;
    padding: 24px 0px;
  }
`;
const ContainerSM = styled.div`
  display: flex;
  padding: 24px 0px;
  @media (min-width: 769px) {
    display: none;
  }
`;

const StyledSelect = styled(Select)`
  width: 208px !important;
`;

const ContainerSelect = styled.div`
  margin-right: 24px;
  opacity: ${(props) => (props.disabled ? '0.6' : '1')};
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
`;

const ContainerButton = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  opacity: ${(props) => (props.disabled ? '0.6' : '1')};
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
`;

const CreateReportButton = styled(Button)`
  width: 100%;
  border-radius: 6px;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding-top: 11px;
  padding-bottom: 11px;
  @media (min-width: 769px) {
    width: 100px;
    padding-left: 6px;
    padding-right: 6px;
  }
  ${theme.breakpoint('lg')} {
    width: 129px;
  }
`;

const FilterNumberMobile = styled.span`
  position: relative;
  background: ${theme.colors.gbrand500};
  border-radius: 50%;
  color: #fff;
  font-family: Roboto;
  font-size: 9px;
  font-weight: 500;
  line-height: 13px;
  z-index: 1;
  margin-top: -25px;
  margin-left: -10px;
  width: 14px;
  height: 14px;
  text-align: center;
  padding-top: 0.5px;
`;

const CleanFiltersContainer = styled.div`
  width: 100%;
  display: flex;
  margin-left: 16px;
`;

export const Filters = ({ handleClickCreateReport }) => {
  const { t } = useTranslation();
  const [showCalendar, setShowCalendar] = useState(false);
  const [intervalDate, setIntervalDate] = useState({ init: undefined, finish: null });
  const { created_at: createdAt, seller } = useSelector((state) => state.login.merchant);
  const { limit_search_report: limitSearchReport, selectTypeReports } = useSelector(
    (state) => state.config
  );
  const [showMobileFilters, setShowMobileFilters] = useState(false);

  const { reports, setFilters, filters, cleanFilters } = useReports();

  const LayoutFilters = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 16px;
    cursor: pointer;
    opacity: ${(props) => (props.disabled ? '0.6' : '1')};
    pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
  `;

  const handleChange = ({ init, finish }) => {
    setIntervalDate({ init, finish });
    init &&
      finish &&
      setFilters({
        type: 'DATA_RANGE',
        dataRange: {
          startDate: getFormatedDate(init, 'yyyy-MM-dd'),
          endDate: getFormatedDate(finish, 'yyyy-MM-dd'),
        },
      });
  };

  const FilterImage = styled(Icon)(
    () => css`
      width: 24px;
      height: 24px;
    `
  );

  const closeFiltersMobile = () => {
    setShowMobileFilters(false);
    setIntervalDate({ init: undefined, finish: null });
  };

  const resetFilters = () => {
    cleanFilters();
    setIntervalDate({ init: undefined, finish: null });
  };

  const noReports = reports?.length === 0;

  const optionsSelectType = selectTypeReports.default;

  return (
    <>
      <ContainerLG>
        {isAllowed('REPORT_FILTER_BY_TYPE') && (
          <ContainerSelect disabled={(filters && filters.dataRange) || noReports}>
            <StyledSelect
              options={selectTypeReports}
              value={filters ? filters.type : ''}
              placeholder={t('reportsScreen.filter.type')}
              onChange={(e) => {
                setFilters({ type: e.target.value });
              }}
              disabled={false}
            />
          </ContainerSelect>
        )}
        <StyledFilter>
          <SyledDateContainer disabled={(filters && !filters.dataRange) || noReports}>
            <IconButton onClick={() => setShowCalendar((state) => !state)}>
              <Icon icon="ic-calendar" />
            </IconButton>
            <StyledDateFilter type="button" onClick={() => setShowCalendar((state) => !state)}>
              {filters && filters.dataRange
                ? `${getFormatedDate(intervalDate.init, 'dd/MM/yyyy')} a ${getFormatedDate(
                    intervalDate.finish,
                    'dd/MM/yyyy'
                  )}`
                : t('transactions.report.selectDate')}
            </StyledDateFilter>
            {filters && filters.dataRange && (
              <IconButton onClick={resetFilters}>
                <Icon id="img-cerrar-x" icon="ic-close-circle" />
              </IconButton>
            )}
          </SyledDateContainer>
        </StyledFilter>
        <StyledDatePicker show={showCalendar}>
          <DatePicker
            show={showCalendar}
            setShow={setShowCalendar}
            onChange={handleChange}
            intervalDateSelect={intervalDate}
            placeholder="Seleccionar fecha"
            minDate={moment(createdAt).toDate()}
            maxDate={moment().toDate()}
            limitDays={
              limitSearchReport && seller.length
                ? limitSearchReport[seller]
                : limitSearchReport['ON THEM']
            }
            topMD="54px"
            widthMD="336px"
          />
        </StyledDatePicker>
        {filters && (
          <CleanFiltersContainer>
            <CleanFilter onClickCleanFilter={resetFilters} />
          </CleanFiltersContainer>
        )}
        <ContainerButton>
          <CreateReportButton id="create-report" onClick={handleClickCreateReport}>
            {t('reportsScreen.createTitle')}
          </CreateReportButton>
        </ContainerButton>
      </ContainerLG>
      <ContainerSM>
        <ContainerButton>
          <CreateReportButton id="create-report" onClick={handleClickCreateReport}>
            {t('reportsScreen.createTitle')}
          </CreateReportButton>
        </ContainerButton>
        <LayoutFilters onClick={() => setShowMobileFilters(true)} disabled={noReports}>
          <FilterImage icon="ic_filters_24" />
          {filters ? <FilterNumberMobile>1</FilterNumberMobile> : ''}
        </LayoutFilters>
      </ContainerSM>
      {showMobileFilters && (
        <Modal
          backgroundColor={`${theme.colors.gray200}`}
          animationDuration="0s"
          bgColorModal={`${theme.colors.gray200}`}
          borderColor="none"
          boxShadow="none"
          borderRadius="1px"
          minWidth="100vw"
          minHeight="100vh"
          animationDurationBg="0s"
          paddingLeft="0px"
          paddingRight="0px"
          paddingBotton="0px"
        >
          <FiltersMobile
            handleResetMobile={resetFilters}
            onClickApplyMobile={() => setShowMobileFilters(false)}
            optionsSelect={optionsSelectType}
            valueSelectMobile={filters ? filters.type : ''}
            onChangeValueSelectType={(e) => {
              setFilters({ type: e.target.value });
            }}
            onClickBackMobile={closeFiltersMobile}
            onButtons={filters}
            filterApplyCalendarMobile={filters && filters.dataRange}
            handleChangeCalendar={handleChange}
            intervalDateCalendar={intervalDate}
            handleResetCalendarMobile={resetFilters}
            intervalDateInit={filters && filters.dataRange && intervalDate.init}
            intervalDateFinish={filters && filters.dataRange && intervalDate.finish}
            disabledSelectTypeMobile={(filters && filters.dataRange) || noReports}
            disabledCalendarMobile={(filters && !filters.dataRange) || noReports}
            limitsDaysMobile={
              limitSearchReport && seller.length
                ? limitSearchReport[seller]
                : limitSearchReport['ON THEM']
            }
            allowedFilterByType={isAllowed('REPORT_FILTER_BY_TYPE')}
          />
        </Modal>
      )}
    </>
  );
};
